jQuery(document).ready(function ($) {
    $('#alert-banner .banner-text').click(function () {
        $('#alert-banner').toggleClass('expanded')
    })

    $('#alert-banner .close-btn').click(function () {
        $('#alert-banner').hide()
    })
})
